import { Link } from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import { HERO_IMAGES } from "../lib/constants";
import { Shield, FileCheck, Users, TrendingUp, Lock, Award } from "lucide-react";

const STATUSES = ["Draft", "Open", "Invitation Only", "Athlete Applied", "Under Review", "Negotiating", "Offered", "Accepted", "Declined", "Active", "Deliverables Due", "Awaiting Payment", "Completed", "Archived"];

export default function NIL() {
    return (
        <PageLayout>
            <section className="relative min-h-[50vh] flex items-end pb-16 pt-32 overflow-hidden border-b border-white/10">
                <img src={HERO_IMAGES.football} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />
                <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="section-label mb-5">NIL Management</div>
                    <h1 className="font-display text-5xl md:text-7xl text-white leading-none tracking-tight" data-testid="nil-heading">
                        LEAD-TO-PAYMENT<br/><span className="text-[#d4af37]">DEAL MANAGEMENT.</span>
                    </h1>
                </div>
            </section>

            <section className="py-16 md:py-24">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-3 gap-4">
                    {[
                        { icon: Shield, t: "Compliance-first", d: "Every deal reviewed for school policy, athletic conference rules and applicable law." },
                        { icon: FileCheck, t: "Contracts, done right", d: "Digital review, e-signature workflow and audit-logged approvals." },
                        { icon: TrendingUp, t: "Transparent tracking", d: "Deal value, commission, athlete net, deliverables and payment status in one view." },
                        { icon: Users, t: "Parent & school workflow", d: "Guardian consent and school-approval tracking built into every deal." },
                        { icon: Lock, t: "Secure & role-based", d: "Documents live in a role-based vault with encryption and access controls." },
                        { icon: Award, t: "Renewals & upsells", d: "We proactively surface renewal opportunities to keep the pipeline moving." },
                    ].map(({icon: I, t, d}) => (
                        <div key={t} className="surface p-7" data-testid={`nil-feat-${t.toLowerCase().replace(/[\s,]+/g,'-')}`}>
                            <I className="text-[#d4af37]" size={26} strokeWidth={1.5} />
                            <div className="font-display text-2xl mt-5 text-white">{t}</div>
                            <p className="text-white/60 mt-3 leading-relaxed text-sm">{d}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="py-16 border-t border-white/10 bg-[#0a0a0a]">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="section-label mb-4">Opportunity Statuses</div>
                    <h2 className="font-display text-3xl md:text-4xl text-white tracking-tight mb-8">Every deal, every stage.</h2>
                    <div className="flex flex-wrap gap-2" data-testid="nil-statuses">
                        {STATUSES.map(s => <span key={s} className="chip">{s}</span>)}
                    </div>
                </div>
            </section>

            <section className="py-20 text-center">
                <div className="max-w-2xl mx-auto px-5">
                    <h3 className="font-display text-3xl md:text-4xl text-white tracking-tight">
                        Ready to run your NIL <span className="text-[#d4af37]">the right way</span>?
                    </h3>
                    <div className="mt-8 flex justify-center gap-3">
                        <Link to="/apply" className="btn-gold" data-testid="nil-apply">Apply for Representation</Link>
                        <Link to="/contact" className="btn-outline" data-testid="nil-contact">Talk to a Manager</Link>
                    </div>
                </div>
            </section>
        </PageLayout>
    );
}
